import {
  isDefined,
  isWorkflowStageId,
  toProgramAutoEnrollmentTrigger,
  toProgramTrigger,
  type ProgramAutoEnrollmentTrigger,
  type ProgramTrigger,
} from '@terros/common'

export const PROGRAM_TRIGGER_TYPES = [
  'userCreated',
  'status',
  'workflowStage',
  'workflowAction',
  'role',
  'team',
  'program',
] as const
export type ProgramTriggerType = (typeof PROGRAM_TRIGGER_TYPES)[number]

export const USER_CREATED_TRIGGER: ProgramAutoEnrollmentTrigger = { type: 'userCreated' }

export function isProgramTriggerType(value: string): value is ProgramTriggerType {
  return PROGRAM_TRIGGER_TYPES.some((type) => type === value)
}

export function getTriggerType(trigger: ProgramAutoEnrollmentTrigger): ProgramTriggerType {
  switch (trigger.type) {
    case 'stage':
      return isWorkflowStageId(trigger.stageId) ? 'workflowStage' : 'status'
    case 'action':
      return 'workflowAction'
    case 'role':
      return 'role'
    case 'team':
      return 'team'
    case 'program':
      return 'program'
    case 'userCreated':
      return 'userCreated'
  }
}

export function getProgramTriggerTypes(triggers: ProgramAutoEnrollmentTrigger[]): ProgramTriggerType[] {
  return [...new Set(triggers.map(getTriggerType))]
}

export function getTriggersOfType(
  triggers: ProgramAutoEnrollmentTrigger[],
  type: ProgramTriggerType
): ProgramAutoEnrollmentTrigger[] {
  if (type === 'userCreated') return [USER_CREATED_TRIGGER]
  return triggers.filter((trigger) => getTriggerType(trigger) === type)
}

export function toTriggerValues<T extends ProgramTrigger>(
  triggers: ProgramAutoEnrollmentTrigger[],
  isValue: (value: ProgramTrigger) => value is T
): T[] {
  return triggers.map(toProgramTrigger).filter(isValue)
}

export function toAutoEnrollmentTriggers(values: ProgramTrigger[]): ProgramAutoEnrollmentTrigger[] {
  return values.map(toProgramAutoEnrollmentTrigger).filter(isDefined)
}
